import { Injectable, signal, WritableSignal } from '@angular/core'
import { createClient } from '@supabase/supabase-js'
import type { AuthError, AuthSession, OAuthResponse } from '@supabase/supabase-js'
import { environment } from "../../../environments/environment";

const DEV_SESSION: AuthSession = {
  access_token: "",
  expires_in: 0,
  refresh_token: "",
  token_type: "bearer",
  user: {
    id: 'dev',
    app_metadata: {},
    user_metadata: {},
    aud: 'dev',
    created_at: 'fake_date',
  }
};

@Injectable({
  providedIn: 'root',
})
export class SupabaseService {
  supabase = createClient(environment.supabaseUrl, environment.supabaseKey);
  session: WritableSignal<AuthSession | null> = signal(null);

  constructor() {
    this.authChanges();
  }

  /**
   * Listen to auth changes
   */
  authChanges(): void {
    if (!environment.production) {
      this.session.set(DEV_SESSION)
      return;
    }
    this.supabase.auth.onAuthStateChange((event, session) => {
      this.session.set(session);
    })
  }

  /**
   * Sign in with Microsoft (Azure)
   */
  signInWithMicrosoft(): Promise<OAuthResponse> {
    return this.supabase.auth.signInWithOAuth({
      provider: 'azure',
      options: {
        scopes: 'openid profile email User.Read',
        redirectTo: window.location.origin + '/sign-in',
      }
    });
  }

  /**
   * Sign out
   */
  signOut(): Promise<{error: AuthError | null}> {
    return this.supabase.auth.signOut()
  }
}